/* eslint-disable */
import { DateTime } from 'luxon';
import styles from './LastUpdatedLabel.module.scss';
import { useTranslation } from 'react-i18next';

export type LastUpdatedLabelProps = {
  date: string;
  userName: string;
};

export const LastUpdatedLabel: React.FC<LastUpdatedLabelProps> = ({
  date,
  userName,
}) => {
  const formattedDate = DateTime.fromISO(date, {
    zone: 'utc',
  })
    .toLocal()
    .toFormat('H:mm ZZZZ - d LLL yyyy');
  const text = `${formattedDate} by ${userName}`;
  const { t } = useTranslation();
  return (
    <span className={styles.lastUpdatedLabel}>
      <strong>{t('lastUpdated')}</strong>
      <span className={styles.lastUpdatedText}>{text}</span>
    </span>
  );
};
